// Turks (tr-TR), cultureApp: zelfde vorm als cultureApp.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appCultureTr = {
    hidden: {
        groupFaithNone: 'İnanç sorusunda "İnanç yok" seçtiğin için gizlendi',
        searchHidden: 'Gizli seçenekler',
    },
    kitchens: {
        filterLabel: 'Mutfak',
        all: 'Tüm mutfaklar',
    },
    menu: {
        suggestionsTitle: 'Bu hafta için öneriler',
        suggestionsHint: 'Bir öneriye dokun ve bir gün seç.',
        noSuggestions: 'Bu hafta için başka öneri yok.',
        whoEats: 'Kimler yiyecek?',
        everyoneEats: 'Herkes yiyecek',
        notEating: '{names} yemeyecek',
        markerLabel: 'Bu yemekte dikkat: {text}',
        chooseDay: 'Bir gün seç: {title}',
    },
    warning: {
        title: 'Bu herkese uygun mu?',
        swapped: 'Değiştirildi: {ingredient} yerine {swap}.',
        eatsOtherSaved: 'Not edildi: {name} bu yemekte başka bir şey yiyor.',
        added: 'Eklendi.',
    },
    recipes: {
        original: '{name}',
    },
};
//# sourceMappingURL=cultureApp.tr.js.map